var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-svg",class:{
    'inline-svg-fill': _vm.color,
    'inline-svg-stroke': _vm.strokeColor
  },style:({
    width: _vm.width,
    height: _vm.height,
    maxWidth: _vm.maxWidth,
    maxHeight: _vm.maxHeight,
    margin: _vm.margin,
    padding: _vm.padding,
    '--inline-svg-color': _vm.color,
    '--inline-svg-stroke-color': _vm.strokeColor
  }),attrs:{"title":_vm.title},domProps:{"innerHTML":_vm._s(_vm.svg)}})}
var staticRenderFns = []

export { render, staticRenderFns }